import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewsRoutingModule } from './news-routing.module';
import { NewsComponent } from './news.component';
import { RelatedComponent } from '../../presentation/related/related.component';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ShareModule } from '../share/share.module';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { HighlighterPipe } from './highlighter.pipe';
import { NlpModule } from '../nlp/nlp.module';

@NgModule({
  declarations: [
    NewsComponent,
    RelatedComponent,
    HighlighterPipe,
  ],
  imports: [
    CommonModule,
    GalleriaModule,
    ImageModule,
    NewsRoutingModule,
    SkeletonModule,
    ProgressSpinnerModule,
    ShareModule,
    AvatarModule,
    AvatarGroupModule,
    NlpModule
    
  ],
  exports: [
    NewsComponent,
    HighlighterPipe
  ]
})
export class NewsModule { }
